<template>
    <v-container>
        <v-layout row justify-space-around>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 xs11 elevation-6>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                        <v-layout row justify-space-between>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold teal--text text--lighten-2"
                                >{{ $t('title')}}</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon color="teal lighten-1">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('btn-cerrar')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider class="teal lighten-1"></v-divider>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="mx-auto transparent" width="100%" elevation="0">
                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p1') "></span>
                                    </v-card-text>

                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p2') "></span>
                                    </v-card-text>

                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p3') "></span>
                                    </v-card-text>

                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p4') "></span>
                                    </v-card-text>

                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 md6>
                                                    <v-list dark dense two-line>
                                                        <v-list-item @click="onDoc1">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-outline</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>13 Common Mistakes Using 360-Degree Feedback</v-list-item-title>
                                                                <v-list-item-subtitle>Optima 360</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc2">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-outline</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>360-Degree Feedback - Best Practices to Ensure Impact</v-list-item-title>
                                                                <v-list-item-subtitle>Creative Leadership</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc3">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-outline</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>360-Degree Feedback - Best Practice Guidelines</v-list-item-title>
                                                                <v-list-item-subtitle>360-Degree Feedback</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc4">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-outline</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Best practices in utilizing 360 degree fedback</v-list-item-title>
                                                                <v-list-item-subtitle>Envisia Learning</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-list dark dense two-line>
                                                        <v-list-item @click="onDoc5">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-outline</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Performance consulting versus performance coaching</v-list-item-title>
                                                                <v-list-item-subtitle>Constructive Choices</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc6">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-outline</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Coaching ejecutivo. Del discurso a la práctica</v-list-item-title>
                                                                <v-list-item-subtitle>Coaching Magazine</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc7">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-outline</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>La evaluación de 360 grados. ¿Moda o Sistema efectivo?</v-list-item-title>
                                                                <v-list-item-subtitle>Qartil</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- </v-card> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'QueEvaluamos',
    data() {
        return {};
    },
    created() {},
    methods: {
        onDoc1() {
            window.open(
                'https://www.retroalimentame.com.mx/informacion/downloads/13CommonMistakes.pdf'
            );
        },
        onDoc2() {
            window.open(
                'https://www.retroalimentame.com.mx/informacion/downloads/360bestpractices.pdf'
            );
        },
        onDoc3() {
            window.open(
                'https://www.retroalimentame.com.mx/informacion/downloads/360bestpractices2.pdf'
            );
        },
        onDoc4() {
            window.open(
                'https://www.retroalimentame.com.mx/informacion/downloads/360bestpractices3.pdf'
            );
        },
        onDoc5() {
            window.open(
                'https://www.retroalimentame.com.mx/informacion/downloads/coachingforperformanceArticulo1.pdf'
            );
        },
        onDoc6() {
            window.open(
                'https://www.retroalimentame.com.mx/informacion/downloads/CoachingEjecutivoDelDiscursoalaPractica.pdf'
            );
        },
        onDoc7() {
            window.open(
                'https://www.retroalimentame.com.mx/informacion/downloads/evaluacion360enespanol.pdf'
            );
        },
        onClose() {
            this.showQueEvaluamosTxt = false;
        }
    },
    computed: {
        ...mapGetters(['waitCursor']),
        showQueEvaluamosTxt: {
            get() {
                return this.$store.getters.showQueEvaluamosTxt;
            },
            set(showQueEvaluamosTxt) {
                this.$store.dispatch(
                    'updateShowQueEvaluamosTxt',
                    showQueEvaluamosTxt
                );
            }
        }
    }
};
</script>

<i18n>
{
    "es": {
        "title": "¿Qué evaluamos?",
        "p1": "A principios del 2008 diseñamos <span style='color:rgb(80, 203, 196);'> <b>retroalimentame.com</b> </span> como una herramienta de apoyo a las organizaciones para su auto-observación, tanto para ejecutivos, como para equipos de trabajo.",
        "p2": "Desde hace algunos años, diferentes autores han venido trabajando el concepto de inteligencia emocional. Todos ellos coinciden en la importancia de la auto-observación como un primer paso, que le permite al individuo o a un e quipo de trabajo, tomar conciencia de la situación actual y comenzar a trabajar en el desarrollo de ciertas competencias específicas.",
        "p3": "En <span style='color:rgb(80, 203, 196);'> <b>retroalimentame.com</b> </span> contamos con una serie de reactivos predeterminados para que tanto los individuos, como los equipos de trabajo puedan sustentar sus planes de desarrollo y un proceso de mejora continua. Contamos también con el soporte de consultores que pueden apoyar a su empresa en la definición de sus competencias corporativas.",
        "p4": "Algunos artículos de interés sobre el tema de retroalimentación e inteligencia emocional aparecen al final de esta sección para que pueda bajarlos para su lectura."
    },
    
    "en": {
        "title": "What do we evaluate?",
        "p1": "In early 2008 we designed <span style='color:rgb(80, 203, 196);'> <b>retroalimentame.com</b> </span> as a support tool for organizations for their self-observation, both for executives and for work teams.",
        "p2": "For some years, different authors have been working on the concept of emotional intelligence. All of them agree on the importance of self-observation as a first step, which allows the individual or a work team to become aware of the current situation and start working on the development of certain specific skills.",
        "p3": "At <span style='color:rgb(80, 203, 196);'> <b>retroalimentame.com</b> </span> we have a series of predetermined reagents so that both individuals and work teams can support their development plans and a process of continuous improvement. We also have the support of consultants who can support your company in defining its corporate competencies.",
        "p4": "Some articles of interest on the topic of feedback and emotional intelligence appear at the end of this section so that you can download them for reading."
    }
}
</i18n>

<style scoped>
.sub-window {
    /* background: rgba(0, 77, 64, 0.6); */
    background: rgba(26, 32, 38, 0.8);
}
</style>